import { useState } from 'react';

interface BookCoverProps {
  src: string | null | undefined;
  title: string | null | undefined;
  size?: 'small' | 'medium' | 'large';
}

function initials(title: string | null | undefined): string {
  if (!title) return '?';
  return title
    .split(/\s+/)
    .filter((word) => /^[\p{L}\p{N}]/u.test(word))
    .slice(0, 2)
    .map((word) => Array.from(word)[0]!.toUpperCase())
    .join('');
}

/** Cover image with a lettered placeholder when there is no cover or it fails to load. */
export function BookCover({ src, title, size = 'medium' }: BookCoverProps) {
  const [failedSrc, setFailedSrc] = useState<string | null>(null);

  if (!src || failedSrc === src) {
    return (
      <div className={`cover cover--${size} cover--placeholder`} aria-hidden="true">
        <span>{initials(title)}</span>
      </div>
    );
  }
  return (
    <img
      className={`cover cover--${size}`}
      src={src}
      alt={title ? `Cover of ${title}` : 'Book cover'}
      loading={size === 'large' ? 'eager' : 'lazy'}
      decoding="async"
      onError={() => setFailedSrc(src)}
    />
  );
}
